export const RESET_SEARCH_STATE = 'Analytics/Search/RESET_SEARCH_STATE';
export const TOGGLE_IS_ADDING_FILTER = 'Analytics/Search/TOGGLE_IS_ADDING_FILTER';
export const SET_FILTERS = 'Analytics/Search/SET_FILTERS';
export const SET_EDITING_FILTER = 'Analytics/Search/SET_EDITING_FILTER';
export const SET_SHORT_TIME_INTERVAL = 'Analytics/Search/SET_SHORT_TIME_INTERVAL';
export const SET_DATE_RANGE = 'Analytics/Search/SET_DATE_RANGE';
export const SET_WHITELISTED_SEGMENT_IDS = 'Analytics/Search/SET_WHITELISTED_SEGMENT_IDS';
